import { Inbox, FolderKanban, Search, Network, User } from "lucide-react";

type Tab = "inbox" | "projects" | "search" | "graph" | "profile";

interface Props {
  active: Tab;
  onChange: (tab: Tab) => void;
}

const items: { id: Tab; icon: React.ReactNode; label: string }[] = [
  { id: "inbox", icon: <Inbox size={22} />, label: "Inbox" },
  { id: "projects", icon: <FolderKanban size={22} />, label: "Проекты" },
  { id: "search", icon: <Search size={22} />, label: "Поиск" },
  { id: "graph", icon: <Network size={22} />, label: "Связи" },
  { id: "profile", icon: <User size={22} />, label: "Профиль" },
];

export function BottomNav({ active, onChange }: Props) {
  return (
    <nav className="fixed bottom-0 inset-x-0 z-30 bg-surface-card/95 backdrop-blur border-t border-white/5 safe-bottom">
      <div className="flex items-center justify-around h-16">
        {items.map((item) => (
          <button
            key={item.id}
            onClick={() => onChange(item.id)}
            className={`flex flex-col items-center gap-0.5 px-3 py-1 transition ${
              active === item.id ? "text-accent" : "text-white/40"
            }`}
          >
            {item.icon}
            <span className="text-[10px] font-medium">{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}